import { Button, Stack } from '@mui/material'
import { Fragment } from 'react'
import { useFormContext } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import type { Image } from '../../../../types/Image'
import type { EditPost } from '../../../../types/Post/EditPost'
import type { CreateStep } from '../../../../types/Step'
import Step from './step'

interface StepsProps {
	steps: Array<CreateStep & { image?: Image | null }>
}

export default function Steps({ steps }: StepsProps) {
	const { postId } = useParams()

	const {
		setValue,
		formState: { errors },
	} = useFormContext<EditPost>()

	function handleAddStep() {
		const stepsWithoutImage = steps.map(({ image, ...step }) => step)

		setValue('steps', [
			...stepsWithoutImage,
			{
				description: '',
				order: steps.length + 1,
				postId: +postId!,
				imageId: null,
			},
		])
	}

	return (
		<Stack direction='column' spacing={1} sx={{ flex: 1, overflow: 'hidden' }}>
			<Stack direction='column' spacing={2} sx={{ overflowY: 'auto' }}>
				{steps.map((step, index) => (
					<Fragment key={index}>
						<Step index={index} step={step} errors={errors?.steps?.[index]} />
					</Fragment>
				))}
			</Stack>
			<Button type='button' variant='text' onClick={handleAddStep}>
				Adicionar Passo
			</Button>
		</Stack>
	)
}
